
import { defineComponent, onBeforeMount, ref } from 'vue';
import { invokegetSkillProf, invokegetAllProxies, deleteProxy, addProxies, invokeProxyImport } from '@/utils/admin/manage_proxy_service';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { invokegetAllProgram, uploadBulkTasks } from '@/utils/admin/task_management_service';
import axios, { AxiosError } from 'axios';
import { getPreSignedUrl } from '@/utils/learner_submit_service';
import SearchBar from '@/components/global/SearchBar.vue';

export default defineComponent({
  name: 'ManageProxy',
  components: { SearchBar },

  setup() {
    const proxyData = ref();
    const renderReady = ref(true);
    const skillData = ref();
    const programDetails = ref();
    const selectedSkill = ref();
    const selectedProgram = ref();
    const userRole = ref();
    const skillName = ref();
    const showScreen = ref(true);
    const showAddProxy = ref(false);
    const showDeleteProxy = ref(false);
    const showAddProxyPanel = ref(false);
    const showSkill = ref(false);
    const proxyCheckOne = ref([]);
    const programErrorMessage = ref();
    const skillErrorMessage = ref();
    const proxyOhr = ref();
    const checkedproxyOhr = ref();
    const checkedproxyRole = ref();
    const roleErrorMessage = ref();
    const proxyErrorMessage = ref();
    const selectedRoles = ref();
    const resMessage = ref();
    const showErrorMessage = ref(false);
    const showSuccessMessage = ref(false);
    const errorMessage = ref();
    const showImportProxy = ref(false);
    const showImportProxyBtn = ref(false);
    const proxyFile = ref();
    const proxyFileName = ref();
    const preSignedUrl = ref();
    const proxyerrorMessage = ref();
    const proxysuccessMessage = ref();
    const proxyDetailsArray = ref();
    const filteredproxyDetails = ref();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const showDeleteBtn = async (event, proxyohr: any, proxyRole: any) => {
      const cb = event.target.checked;
      if (cb === true) {
        checkedproxyOhr.value = proxyohr;
        checkedproxyRole.value = proxyRole;
        showDeleteProxy.value = true;
      } else {
        showDeleteProxy.value = false;
      }
    };
    const getAllProxyList = async () => {
      let url = `/v2/admin/proxy/program/${selectedProgram.value}`;
      if (!selectedProgram.value) {
        programErrorMessage.value = 'Please Select Program';
        setTimeout(() => {
          programErrorMessage.value = null;
        }, 6000);
        return;
      }
      if (selectedProgram.value === 'infinity') {
        url = `/v2/admin/proxy/program/infinity/skill/${selectedSkill.value}`;
        if (!selectedSkill.value || selectedSkill.value === 'Select Skill') {
          skillErrorMessage.value = 'Please Select Skill';
          setTimeout(() => {
            skillErrorMessage.value = null;
          }, 6000);
          return;
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      // const data: any = {
      //   linked_program_name: selectedProgram.value,
      //   skill_id: selectedSkill.value,
      // };
      // proxyData.value = await invokeGetProxyList('/getAllProxyBySkill', selectedSkill.value);
      const res = await invokegetAllProxies(url);
      proxyData.value = res.all_proxies;
      proxyDetailsArray.value = proxyData.value.map((proxy) => proxy.proxy_name);
      filteredproxyDetails.value = proxyData.value;
      console.log('proxyDetailsArray Data', proxyDetailsArray.value);
      console.log('Proxy Data', proxyData.value);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      // const filtered = skillData.value.filter((el: any) => {
      //   const skill = el.skill_id;
      //   if (skill) {
      //     return skill === selectedSkill.value;
      //   }
      //   return false;
      // });
      // skillName.value = skill;
      // showAddProxy.value = true;
    };
    const proxycheckedOne = () => {
      proxyCheckOne.value = [];
    };
    const DeleteProxy = async () => {
      renderReady.value = false;
      try {
        const data = {
          proxy_ohr: checkedproxyOhr.value,
          proxy_skill: selectedSkill.value,
          program_id: selectedProgram.value,
          proxy_role: checkedproxyRole.value,
        };
        console.log('Data for Delete', data);
        const deleteRes = await deleteProxy('/v2/admin/proxy/delete', data);
        resMessage.value = deleteRes;
        console.log(deleteRes);
        renderReady.value = true;
        showSuccessMessage.value = true;
        // console.log(`showSuccessMessage.value ${JSON.stringify(res)}`);
        setTimeout(() => {
          showSuccessMessage.value = false;
        }, 2000);
        await getAllProxyList();
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          console.log(`errorMessage.value ${errorMessage.value}`);
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 2000);
        }
      }
    };

    const addProxy = async () => {
      try {
        if (selectedProgram.value !== 'infinity') {
          selectedRoles.value = 'Knowledge Manager';
        }
        if (!proxyOhr.value) {
          proxyErrorMessage.value = 'Please Enter OHR';
          setTimeout(() => {
            proxyErrorMessage.value = null;
          }, 6000);
          return;
        }
        if (selectedRoles.value === 'Select Role' || selectedRoles.value === undefined) {
          roleErrorMessage.value = 'Please Enter Roles';
          setTimeout(() => {
            roleErrorMessage.value = null;
          }, 6000);
          return;
        }
        renderReady.value = false;
        const data = {
          proxy_skill: selectedSkill.value,
          program_id: selectedProgram.value,
          proxy_role: selectedRoles.value,
          proxy_ohr: proxyOhr.value,
        };
        const addRes = await addProxies('/v2/admin/proxy', data);
        resMessage.value = addRes;
        // console.log(deleteRes);
        renderReady.value = true;
        showSuccessMessage.value = true;
        // console.log(`showSuccessMessage.value ${JSON.stringify(res)}`);
        setTimeout(() => {
          showSuccessMessage.value = false;
          showAddProxyPanel.value = false;
          selectedRoles.value = null;
          proxyOhr.value = null;
        }, 2000);
        await getAllProxyList();
        // console.log('/v2/admin/proxy', data);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          console.log(`errorMessage.value ${errorMessage.value}`);
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 2000);
        }
      }
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedProgram = async (e: any) => {
      showAddProxyPanel.value = false;
      renderReady.value = false;
      selectedProgram.value = e.target.value;
      console.log('Selected Program', selectedProgram.value);
      if (selectedProgram.value !== 'Select Program') {
        if (selectedProgram.value === 'infinity') {
          showSkill.value = true;
          showAddProxy.value = false;
        } else {
          selectedSkill.value = '';
          showSkill.value = false;
          showImportProxyBtn.value = true;
          showAddProxy.value = true;
        }
        // localStorage.setItem('inputValue', selectedProgram.value);
        // await getTaskDetails();
      }

      showImportProxyBtn.value = true;
      renderReady.value = true;
      // localStorage.setItem('program', selectedProgram.value);
      // localStorage.removeItem('inputValue');
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedRoles = async (e: any) => {
      selectedRoles.value = e.target.value;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedSkill = async (e: any) => {
      // console.log(e.target.removeAttr('selected'));
      renderReady.value = false;
      selectedSkill.value = e.target.value;
      if (selectedSkill.value !== 'Select Skill') {
        showAddProxy.value = true;
      } else {
        showAddProxy.value = false;
      }
      console.log('selectedSkill.value', selectedSkill.value);

      // proxyData.value = await invokeGetProxyList('/getAllProxyBySkill', selectedSkill.value);
      // // eslint-disable-next-line @typescript-eslint/no-explicit-any
      // const filtered = skillData.value.filter((el: any) => {
      //   const skill = el.skill_id;
      //   if (skill) {
      //     return skill === selectedSkill.value;
      //   }
      //   return false;
      // });
      // skillName.value = filtered[0].skill_alias;
      // for (let index = 0; index < proxyData.value.length; index += 1) {
      //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
      //   const res: any = index;
      //   res.skillName = filtered[0].skill_alias;
      // }
      // console.log(filtered[0].skill_alias);

      // console.log(proxyData.value);
      renderReady.value = true;
    };

    const getallSkillList = async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const skillRes: any = await invokegetSkillProf('/getAllSkillProf?skill_type=genome');
      skillData.value = skillRes.skill;
    };
    const getProgram = async () => {
      renderReady.value = false;
      programDetails.value = await invokegetAllProgram('/cache?cache=program');
      // console.log(programDetails.value);
      renderReady.value = true;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectedFile = async (event: any) => {
      const file = event.target.files[0];
      const fileName = file.name;
      const isFileCSV = fileName.endsWith('.csv');
      if (!isFileCSV) {
        proxyerrorMessage.value = 'Please Select valid file to upload, only CSV file is allowed';
        setTimeout(() => {
          proxyerrorMessage.value = null;
        }, 6000);
        proxyFile.value = null;
        proxyFileName.value = null;
      } else {
        proxyFileName.value = fileName;
        proxyFile.value = file;
      }
    };
    const bulkImportProxy = async () => {
      if (!proxyFileName.value) {
        proxyerrorMessage.value = 'Please Select valid file to upload, only CSV file is allowed';
        setTimeout(() => {
          proxyerrorMessage.value = null;
        }, 6000);
        return;
      }

      //   const now = moment().format('llll');
      renderReady.value = false;
      try {
        const keyName = 'proxy_flat.csv';
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const preSignedRes: any = await getPreSignedUrl('/v1/pretAuthUrlForUpload', {
          folder_name: 'users',
          key_name: keyName,
        });
        console.log('presigned URL', preSignedRes);
        preSignedUrl.value = preSignedRes.data.preSignedUrl;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const uploadedRes: any = await uploadBulkTasks(preSignedUrl.value, proxyFile.value);
        if (uploadedRes.status === 200) {
          const importProxy = await invokeProxyImport('/seed/proxy/program/v2', { program_id: selectedProgram.value });
          proxysuccessMessage.value = importProxy;
          await getAllProxyList();
          setTimeout(() => {
            proxysuccessMessage.value = null;
            showImportProxy.value = false;
          }, 6000);
        }
        renderReady.value = true;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(err.response?.data);
          renderReady.value = true;
          proxyerrorMessage.value = (err.response?.data as { message: string })?.message;
          setTimeout(() => {
            proxyerrorMessage.value = false;
          }, 2000);
        }
      }
    };
    const getFilteredList = (value) => {
      // filteredProgramDetails.value = value;
      // console.log('ProgramDetails.value in final', ProgramDetails.value);
      filteredproxyDetails.value = proxyData.value.filter((proxy) => value.includes(proxy.proxy_name));
      console.log('filteredproxyDetails', filteredproxyDetails.value);
    };
    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        console.log('inside length');
        if (userRole.value.includes('System Admin') || userRole.value.includes('Proxy Admin') || userRole.value.includes('Community Manager')) {
          showScreen.value = true;
        } else {
          showScreen.value = false;
        }
      }
      // userRole.value = localStorage.getItem('user_roles') ? localStorage.getItem('user_roles') : [];
      // if (userRole.value.length > 0) {
      //   if (userRole.value.includes('System Admin') || userRole.value.includes('System Admin View Access') || userRole.value.includes('Proxy Admin')) {
      //     showScreen.value = true;
      //   } else {
      //     showScreen.value = false;
      //   }
      // }
      await getProgram();
      getallSkillList();
    });

    return {
      proxyData,
      renderReady,
      skillData,
      getSelectedSkill,
      showScreen,
      skillName,
      programDetails,
      getAllProxyList,
      showAddProxy,
      showDeleteProxy,
      proxyCheckOne,
      showDeleteBtn,
      proxycheckedOne,
      showSkill,
      getSelectedProgram,
      programErrorMessage,
      skillErrorMessage,
      showAddProxyPanel,
      proxyOhr,
      roleErrorMessage,
      proxyErrorMessage,
      addProxy,
      getSelectedRoles,
      DeleteProxy,
      showErrorMessage,
      resMessage,
      errorMessage,
      showSuccessMessage,
      showImportProxy,
      bulkImportProxy,
      proxyFile,
      proxyFileName,
      preSignedUrl,
      selectedFile,
      proxyerrorMessage,
      proxysuccessMessage,
      showImportProxyBtn,
      selectedProgram,
      proxyDetailsArray,
      getFilteredList,
      filteredproxyDetails,
    };
  },
});
